import { useContext } from "react";
import { MagasinContext } from "../../Context/MagasinContext";
import axios from "axios";

export default function AfficheArticlesCCInfo(id:any){
    const urlShowArticle = `${process.env.REACT_APP_PHP_APP_URL}/magasinc/${id}/commercial/articles`;
    const getArticle=()=>{
        return (axios.get(urlShowArticle));
    }
    return {
        getArticle
    }
}